import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ServiceProviderService } from 'src/app/services/service-provider.service';
import * as _ from "lodash";
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import swal from 'sweetalert2'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NavigationService } from 'src/app/services/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { MatDatepicker } from '@angular/material/datepicker';
import { Moment } from 'moment';
import * as moment from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_DATE_FORMATS } from 'src/app/shared/validators/mat-date-formatter';
import { MatDialog } from '@angular/material/dialog';
import { PopupSalesTargetSetupComponent } from '../sales-target-setup-popup/sales-target-setup-popup.component';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
    selector: 'app-sales-target-setup-add',
    templateUrl: './sales-target-setup-add.component.html',
    styleUrls: ['./sales-target-setup-add.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },

        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
})
export class AddSalesTargetSetupComponent implements OnInit {
    form: FormGroup;
    id: any;
    type: any;
    filterValue: string = ''
    data = [];
    dataSource = new MatTableDataSource(this.data);
    displayedColumns: string[] = [
        "providerName",
        "targetDayCount",
        "targetMonthCount",
        "targetYearCount",
        "effectiveFrom",
        "action"
    ];
    salesTargetUserName: string;
    @ViewChild('monthFilter') monthFilterPicker: MatDatepicker<Date>;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    serviceProviderList: any = [];
    filterserviceProviderList: any = [];
    checkHCYear: boolean = false;
    date = new FormControl(moment());

    constructor(private ServiceProviderService: ServiceProviderService,
        private navigationService: NavigationService,
        private activateroute: ActivatedRoute,
        private matdialog: MatDialog,
        private LookupDataServiceService: LookupDataServiceService,
        private fb: FormBuilder,
        private toastr: NotificationService
    ) {
        this.activateroute.params.subscribe((params: any) => {
            this.id = parseInt(params.id);
            this.type = parseInt(params.type);
        });
    }

    ngOnInit() {
        this.initializeValidators();
        this.getTableData();
        this.getCompanyName();
        this.getServiceProvider();
        this.getHCYearFormat();
    }

    initializeValidators() {
        this.form = this.fb.group({
            monthFilter: [''],
            serviceProviderId: [null]
        });
    }

    getServiceProvider() {
        this.LookupDataServiceService.getServiceProvider().subscribe((result) => {
            this.serviceProviderList = result;
            this.filterserviceProviderList = this.serviceProviderList.slice();
        });
    }

    getHCYearFormat() {
        this.ServiceProviderService.getHCYearFormat(this.id).subscribe((result) => {
            this.checkHCYear = result;
            if (this.checkHCYear) {
                if (this.type !== 2) {
                    this.displayedColumns = ["providerName", "targetMonthCount", "targetYearCount", "effectiveFrom", "action"];
                } else {
                    this.displayedColumns = ["providerName", "targetMonthCount", "targetYearCount", "effectiveFrom"];
                }
            } else {
                if (this.type !== 2) {
                    this.displayedColumns = ["providerName", "targetDayCount", "targetMonthCount", "effectiveFrom", "action"];
                } else {
                    this.displayedColumns = ["providerName", "targetDayCount", "targetMonthCount", "effectiveFrom"];
                }
            }
        });
    }

    getCompanyName() {
        this.ServiceProviderService.getSalesUserNamebyId(this.id).subscribe((result) => {
            this.salesTargetUserName = result;
        });
    }

    getTableData() {
        this.ServiceProviderService.getSalesTargetListbyId(this.id).subscribe((result) => {
            this.data = [];
            if (result) {
                this.data = result;
            }
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }

    salestargetfilterSearchClick() {
        let postData: any = {};
        postData.userId = this.id;
        postData.serviceProviderId = this.form.value.serviceProviderId;
        postData.monthFilter = moment(this.form.value.monthFilter, 'MMM/YYYY').format("YYYY/MM/DD");
        this.ServiceProviderService.getSalesTargetFilterSearch(postData).subscribe((result) => {
            this.data = [];
            if (result) {
                this.data = result;
            }
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }

    FnmonthFilterPicker() {
        this.monthFilterPicker.open();
    }

    setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value ?? moment();
        ctrlValue.month(normalizedMonthAndYear.month());
        ctrlValue.year(normalizedMonthAndYear.year());
        this.form.controls['monthFilter'].setValue(ctrlValue);
        datepicker.close();
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.filterValue = filterValue;
        // this.dataSource.filter = filterValue.trim().toLowerCase();
        // if (this.dataSource.paginator) {
        //     this.dataSource.paginator.firstPage();
        // }
    }

    clearFilter() {
        const inputElement = document.getElementById('filter-input') as HTMLInputElement;
        if (inputElement) {
            inputElement.value = '';
        }
        this.dataSource.filter = '';
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
        this.dataSource.sort.active = '';
        this.dataSource.sort.direction = '';
        this.dataSource.sort.sortChange.emit({ active: '', direction: '' });
        this.form.reset();
        this.getTableData();
    }

    gotoSalesTargetSetup() {
        this.navigationService.gotoSalesTargetSetup();
    }

    openPopup(dataField) {
        dataField = {
            ...dataField,
            userId: this.id
        }
        const dialogref = this.matdialog.open(PopupSalesTargetSetupComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog',
            width: "650px",
            // height: "530px",
            data: dataField
        });
        dialogref.afterClosed().subscribe(res => {
            if (res) {
                this.clearFilter();
            }
        })
    }

    deleteUser(id) {
        if (id && id !== 0) {
            const txt = 'Are you sure want to Delete ?';
            const Yes = 'Yes';
            const No = 'No';
            swal.fire({
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#7D32DE',
                cancelButtonColor: '#23C00A',
                confirmButtonText: Yes,
                cancelButtonText: No,
            }).then((result) => {
                if (result.value) {
                    this.ServiceProviderService.deleteSalesTarget(id).subscribe((result) => {
                        if (result == 2) {
                            this.toastr.showSuccess("Deleted successfully!");
                        }
                        this.clearFilter();
                    });
                }
            });
        }
    }
}
